module.exports = __webpack_public_path__ + "img/52_31.ec714616.png";